import { Wrap, Tag, TagCloseButton } from '@wegroup/design-system';
import React from 'react';
import { NaceCode } from '../../../../types/CompanyScanTypes';

interface Props {
  naceCodes: NaceCode[];
  setNaceCodes: (codes: NaceCode[]) => void;
  onRemove: (nace: NaceCode) => void;
}

const NaceCodeTags: React.FC<React.PropsWithChildren<Props>> = ({
  naceCodes,
  onRemove,
}) => {
  return (
    <Wrap spacing="2">
      {naceCodes
        .sort((a, b) => parseInt(a.level) - parseInt(b.level))
        .map((naceCode) => (
          <Tag key={naceCode.code}>
            {naceCode.code}: {naceCode.label}{' '}
            <TagCloseButton onClick={() => onRemove(naceCode)} />
          </Tag>
        ))}
    </Wrap>
  );
};

export default NaceCodeTags;
